var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#504C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09019 8.649L5.10862 10.7291L5.56538 12.4346L6.7275 12.7451L8.16975 14.1891L7.7355 14.625L4.2975 13.7025L3.375 10.2645L4.06687 9.57375L7.07175 6.56831L6.09019 8.649L5.10862 10.7291L8.16975 7.668L7.07175 6.56831L6.09019 8.649ZM7.668 9.83025L10.7291 12.8914L12.4346 12.4346L12.7463 11.2725L14.1891 9.83025L14.625 10.2645L13.7036 13.7036L10.2645 14.625L6.56944 10.9282L7.668 9.83025ZM10.332 8.16975L7.27087 5.10862L5.56425 5.56538L5.25375 6.72581L3.81094 8.16975L3.375 7.7355L4.2975 4.29638L7.7355 3.375L8.42625 4.06687L11.43 7.07062L10.332 8.16975ZM11.2725 5.25375L9.83025 3.81094L10.2645 3.375L13.7036 4.29638L14.625 7.7355L10.9282 11.4306L9.83025 10.332L12.8925 7.26975L12.4346 5.56425L11.2725 5.25375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtm);
export default __webpack_public_path__ + "static/media/btm.99ccff03b05ed4c0e5a054fbb04b7639.svg";
export { ForwardRef as ReactComponent };